import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import Payment from "../../payment/types/Payment";

type Output = Payment[];

export default function useTransferPaymentsGet(
  uuid: any,
    options?: CacheQueryOpts
): CacheQueryOutput<Output> {
    const client = useAPIClient();
    return useCacheQuery<Output>(
    ["transfer-payments", uuid],
    () => {
      // Add default filters: request up to 500 items and only paid payments
      return client.get<any>(`transfers/` + uuid + `/payments`, {
        itemsPerPage: 500,
        paid: true,
      });
    },
    options
  );
}

